export const language: any ={
    cancel:"Cancel",
    ok:"Ok",
}